import React, { memo, useCallback, useState } from 'react';
import classnames from 'classnames';
import styles from './GameRate.module.less';

export default memo(props => {
  const { score, styleType, className } = props;
  const star = `star ${className}`;
  const iconStaron_def = ` icon-staron star_grey`;
  let iconStaron_main = ` icon-staron start_black`;
  if (styleType === 'black') {
    iconStaron_main = ` icon-staron start_black`;
  } else if (styleType === 'white') {
    iconStaron_main = ` icon-staron start_white`;
  }

  const starOnCount = Math.floor(Number(parseFloat(score) + 0.5)) || 0;

  return (
    <span className={styles.rate}>
      <span
        className={classnames(
          star,
          'iconfont',
          starOnCount >= 1 ? iconStaron_main : iconStaron_def,
        )}
      />
      <span
        className={classnames(
          star,
          'iconfont',
          starOnCount >= 2 ? iconStaron_main : iconStaron_def,
        )}
      />
      <span
        className={classnames(
          star,
          'iconfont',
          starOnCount >= 3 ? iconStaron_main : iconStaron_def,
        )}
      />
      <span
        className={classnames(
          star,
          'iconfont',
          starOnCount >= 4 ? iconStaron_main : iconStaron_def,
        )}
      />
      <span
        className={classnames(
          star,
          'iconfont',
          starOnCount >= 5 ? iconStaron_main : iconStaron_def,
        )}
      />
    </span>
  );
});
